import * as React from 'react'
export default class MailingListsEmpty extends React.PureComponent<any> {
  render(): React.ReactElement<'svg'> {
    return (
      <svg height="85" width="85" viewBox="0 0 85 85">
        <path
          d="M42.5 85C65.972 85 85 65.972 85 42.5S65.972 0 42.5 0 0 19.028 0 42.5 19.028 85 42.5 85z"
          fill="#F3F3F3"
        />
        <path
          d="M0 4h28V0H0v4zm0 8h28V8H0v4zm0 8h28v-4H0v4zm32 0h4v-4h-4v4zm0-20v4h4V0h-4zm0 12h4V8h-4v4z"
          fill="#939ff8"
          transform="translate(24 33)"
        />
        <defs>
          <path
            id="a"
            d="M42.5 85C65.972 85 85 65.972 85 42.5S65.972 0 42.5 0 0 19.028 0 42.5 19.028 85 42.5 85z"
          />
          <path
            id="b"
            d="M0 4h28V0H0v4zm0 8h28V8H0v4zm0 8h28v-4H0v4zm32 0h4v-4h-4v4zm0-20v4h4V0h-4zm0 12h4V8h-4v4z"
          />
        </defs>
      </svg>
    )
  }
}
